import type { defaultDependencies } from './defaultDependencies'
import { use } from 'react'
import { DependenciesContext } from '@/scopes/common/infrastructure/dependencies/DependenciesContext'
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export const useDependencies = () => use(DependenciesContext) as Required<typeof defaultDependencies>

type Dependencies = typeof defaultDependencies
type DependencyKey = keyof Dependencies
export const useDependency = <N extends DependencyKey>(name: N): Dependencies[N] => useDependencies()[name]
